 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		30: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"/node_modules/litepicker-polyfills-ie11/dist","1":"adobeDigitalData","2":"alertSignUpSection","3":"article","4":"binders","7":"bulkDownload","8":"citedBy","9":"confirmationDialog","10":"copyText","11":"dashboardToolbar","12":"datepicker","13":"disableADBlocker","14":"downloadCitations","15":"eventPage","16":"examCertificate","17":"exportCitation","18":"fancybox","19":"favorites","20":"headerAlt","21":"healthcareDisclaimer","22":"institutionBanner","23":"institutionDetails","24":"institutionSearch","25":"keveladplaceholder","26":"lazy-imports","27":"loadAbst","28":"loi","29":"loiAccordion","31":"menu","32":"mrw","33":"personalInformation","35":"profile","36":"progressBar","37":"publicationVersion","38":"readCubeShare","39":"recommendToLibrarian","40":"requestidlecallback-polyfill","41":"sciteMetrics","42":"search","43":"showRecommended","44":"sidebarSections","45":"slideshow","46":"slot-license-consumption","47":"slotLicense","48":"tfa","49":"toggleTable","50":"topContent","51":"truncate","52":"utm","53":"vendors~article","54":"vendors~dynamic-imports","55":"vendors~fancybox","56":"vendors~fileUploader","57":"vendors~ie-imports","58":"vendors~lazy-imports","59":"vendors~pd","60":"vendors~profile","61":"vendors~sciteMetrics","62":"vendors~search","63":"vendors~slideshow"}[chunkId]||chunkId) + "-" + {"0":"e34bccbfbec8ba012a37","1":"20800f0de1c7cd836b30","2":"eb19742222c427cf3887","3":"2042022af98771548ced","4":"694213f1b2306973c997","7":"3e14339cd14543699f78","8":"4b31f62f41d43d558e73","9":"67d138f0e22eb39a8e1a","10":"0c6e987bc5ad40f2ce8b","11":"0b14c8d2279706c60819","12":"d6edb8abe5faef2d119b","13":"69ebc07e6b59bc993b94","14":"83241eb9f8067ba3711f","15":"797049dd63f370fa78d0","16":"8aefd7aa4655fc82184e","17":"27eb4758982ba120d222","18":"32b301d9ee4465691e29","19":"05f065a91db76582ba31","20":"26e3662b43f146fdb3e9","21":"5f22f84cdf16203596da","22":"2853676d5b50d87b923d","23":"6c734993a0ca96afa9de","24":"d79553a004b165b9bd6c","25":"e83c74458753d4db2e92","26":"2c56d0272c8ea3d040c0","27":"8027b2be412b0406b659","28":"10b9ef189b6240bf4f16","29":"3e930652c89fbc0e746f","31":"9c7995a67ff04429e66d","32":"9887e9f896c422e85aba","33":"b85fe9a09694451ff64e","35":"44fc774507aa46b8dec5","36":"41fb4b4b5795c9505ea9","37":"e1fda66cf5852e2e4a72","38":"8d2ea4063cb99cbd3198","39":"31aaf3809a9ae61f72a9","40":"872fd5dae3ac029825c1","41":"731de5c6f9c6d6ce4656","42":"74d7fc5f00036bbfe8a7","43":"78ad9e5524ee6f8d3a94","44":"024ae71b27d582cb442f","45":"b9bcadb59422f798157a","46":"4c0dfc441d64fa2e7a72","47":"770964d45e21e4b1fae9","48":"cfc0f3007027fe1e6c77","49":"acf9ad76ad306305b28b","50":"73b607747930c44347cb","51":"646146bf313dcde2509e","52":"ada856309c7a03046ac2","53":"003f174ecc320e4bbcdf","54":"35e5e3790d9eb0676bea","55":"19f146dffc82360d68c4","56":"f14fd032592872f31eb1","57":"066b2ccae376d39d8b3a","58":"90dc14b857c914bb911f","59":"e4d450ea93eff5d6f307","60":"ec3a6ceb4a7ef57eecd9","61":"3767b810479f4c93efdd","62":"f2188c5c7c4f59e6d222","63":"12d96b13d92bddd5ebc5","64":"02eaa1b9c6d6c9e1eaf2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 103);
